module.exports = __webpack_public_path__ + "img/carousel-4.e463ef25.png";